import { useEffect, useState } from 'react';
import { Row, Col } from '../../ui/ot';
import FrontendNews from '../../news/views/frontend_news';
import CarouselComponent from '../components/carousel_component';
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import QuickLinksSection from "./quick_links_section"
import { QuestionAndAnswerAccordion } from "../../question_and_answer/views/question_and_answer"
import Appointment from "../Appointment";
import LocationSection from "./location_section"
import CalendarWidget from "../../../components/component_layout/components/calendar_widget"
import SearchBar from "../../../components/online_public_catalog_query_construction/views/search_bar"
import NewArrivalsListShow from '../../Library/views/new_arrivals_list_show';
import styled from "styled-components";

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: 700;
  color: #1e40af;
`

const ViewAll = styled.a`
  font-size: 0.875rem;
  font-weight: 500;
  color: #1d4ed8;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
const HomePage = ({ prefixTitle }) => {

  const carouselController = useCRUDController({ apiRoute: "/system/frontend/classify_structure_type_carousel" })

  useEffect(() => {
    document.title = `${prefixTitle} | 首頁`;
  }, [prefixTitle]);

  const defaultCarouselData = [
    {
      "frontend_component_blog_type_id": 1,
      "blog_type_hidden_name": false,
      "blog_type_id": 2922,
      "blog_type_name": "區塊標題呈現區",
      "frontend_column_frontend_component_blog_type_blog_data": [
        {
          "blog_type_blog_id": 1,
          "blog_id": 100,
          "title": "文章標題1",
          "content": "文章內容1",
          "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
          "top": null,
          "top_edit_time": null,
          "blog_index": null,
          "more_content": "詳細資料１",
          "show": null,
          "external_link": "",
          "youtube_iframe": null,
          "youtube_thumbnail": null,
          "property_json": null,
          "extermal_link_check": 1,
          "blog_type_classify_structure_type_blog_data": [
            {
              "classify_structure_type_id": null,
              "file_id": null,
              "default_image": "/afatsBanner1.jpeg"
            },
            {
              "classify_structure_type_id": null,
              "file_id": null,
              "default_image": "/afatsBanner2.jpeg"
            }
          ]
        },
      ]
    }
  ]
  const dataTransferBlog = (carouselArray) => {
    console.log(carouselArray)

    let imageData = []
    imageData = carouselArray.map((carouselData, index) => {
      return {
        "classify_structure_type_id": carouselData.classify_structure_type_id,
        "file_id": carouselData.classify_structure_type_file_data?.[0]?.file_id ?? null
      }
    });

    let result = defaultCarouselData
    result[0].frontend_column_frontend_component_blog_type_blog_data[0].blog_type_classify_structure_type_blog_data = imageData
    console.log(result)
    return result;
  }

  const [layoutDirection, setLayoutDirection] = useState("vertical");

  useEffect(() => {
    carouselController.getData({ 
      
    })
    const updateLayout = () => {
      const width = window.innerWidth;
      if (width >= 768 && width < 992) {
        setLayoutDirection("horizontal"); // 只有 md 區間橫排
      } else {
        setLayoutDirection("vertical"); // 其他情況直排
      }
    };

    updateLayout(); // 初始化時也要跑一次
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  const calendarProps = { showEvents: true };

  return (
    <Row gutter={[8, 8]}
      justify={'center'}
      // align={'middle'}
      style={{
        padding: "1rem"
      }}>
      <Col xxl={18} xl={18} lg={16} md={24} sm={24} xs={24} >
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <SearchBar
              propsNavigateSearchPath={'/library'}></SearchBar>
          </Col>
          <Col span={24}>
            {
              carouselController.ResponseData && carouselController.ResponseData.length !== 0
                ?
                <CarouselComponent
                  blogTypeData={dataTransferBlog(carouselController.ResponseData)}
                ></CarouselComponent>
                :
                <CarouselComponent
                  blogTypeData={defaultCarouselData}
                ></CarouselComponent>
            }
          </Col>
        </Row>
      </Col>
      <Col xxl={6} xl={6} lg={8} md={24} sm={24} xs={24}>
        <CalendarWidget
          {...calendarProps}
          layoutDirection={layoutDirection}
        />
      </Col>
      <Col span={24}>
        <FrontendNews
          size={6}
          viewAll={true}
          viewAllRoute={'/officialweb/frontend/news'}
          newRoute={'/officialweb/frontend/new'}
        ></FrontendNews>
      </Col>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <TitleRow>
              <Title>書單展示</Title>
              <ViewAll href={'/library/online_public_catalog_query_construction/display_list'}>查看全部 →</ViewAll>
            </TitleRow>
          </Col>
          <Col span={24}>
            <NewArrivalsListShow
              showCount={1}
            />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <QuickLinksSection></QuickLinksSection>
      </Col>
      <Col span={24}>
        <QuestionAndAnswerAccordion />
      </Col>
      <Col span={24}>
        <LocationSection></LocationSection>
      </Col>
      <Col span={24}>
        <Appointment
          title={"意見回饋"}
          sectionColor={"#ffffff"}
        />
      </Col>
    </Row>
  );
};

export default HomePage;
